import { MDBIcon, MDBBtn, MDBInput } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import uploadIcon from "../../images/upload.svg";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { useFieldArray, useFormContext } from "react-hook-form";
import {
  downloadLunaPDF,
  getLunaGreetingInfo,
  getSummaryInformation,
} from "../../../apiclients/streamsapi_bridge";
import { sanitizeAndLowercase } from "../../../apiclients/CommonUtils";
import TextareaAutosize from "react-textarea-autosize";
import UIConstant from "../../../apiclients/UIConstant";

function LunaGreeting({
  scheduleId,
  twentyFourSeven,
  holidayGreetings,
  greetStatus,
  setgreetStatus,
  uploadedFiles,
  setUploadedFiles,
  lunaid,
  holidayCustomInfo,
  setholidayCustomInfo,
  setcommonGreetingInfo,
  commonGreetInfo,
  commonGreetingIdName,
  setinterErrorMessage,
  setIsloading,
  setregenerateFlag,
  regenerateFlag,
  infoError,
  setinfoError,
  pdfInfo,
  setpdfInfo,
  voiceType,
  greetError,
  setgreetError,
  isActive,
  onResetDone,
}) {
  const [selectedFiles, setSelectedFiles] = useState();
  const [fileSize, setfileSize] = useState(0);
  const { t, i18n } = useTranslation();
  const fileInputRef = useRef(null);
  const [holidaysGreet, setholidaysGreet] = useState([]);
  const audioRef = useRef(null);
  const [blobURL, setBlobURL] = useState(null);
  const [playVoiceId, setplayVoiceId] = useState("");
  const [deletedFilesList, setdeletedFilesList] = useState([]);

  const {
    setValue,
    watch,
    control,
    reset,
    clearErrors,
    formState: { errors },
    setError,
    register,
  } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "greet.edit_perm",
  });

  useEffect(() => {
    if (!uploadedFiles || uploadedFiles.length === 0) {
      setSelectedFiles([]);
    }
  }, [uploadedFiles]);
  const uploadedfileList = watch("pdfs");
  useEffect(() => {
    if (holidayGreetings && holidayGreetings.length > 0 && scheduleId === 4) {
      setholidaysGreet(holidayGreetings);
      reset((prev) => ({
        ...prev,
        greet: { ...prev.greet, edit_perm: holidayGreetings },
      }));
      onResetDone?.();
    }
  }, [holidayGreetings]);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    document
      .getElementById("uploadFile")
      .parentNode.classList.remove("draging");
    document.getElementById("uploadFile").parentNode.classList.add("dragBox");
    const file = event.dataTransfer.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (fileExtension === "pdf") {
        setSelectedFiles([...(selectedFiles ? selectedFiles : []), file]);
        setUploadedFiles([...(selectedFiles ? selectedFiles : []), file]);
        setValue("pdfs", [...(selectedFiles ? selectedFiles : []), file], {
          shouldDirty: true,
        });
      } else {
        alert("Please select only a PDF file.");
      }
    }
  };

  const handleFileUpload = (event) => {
    event.preventDefault();
    event.stopPropagation();
    clearErrors("pdfs");

    const files = Array.from(event.target.files);

    event.target.value = "";
    const newUploadedFiles = [...(uploadedFiles ? uploadedFiles : [])]; // Copy existing files
    const existingFiles = newUploadedFiles.map((file) => file.name);
    const duplicates = files.filter((file) =>
      existingFiles.includes(file.name)
    );
    if (duplicates && duplicates.length > 0) {
      const name = duplicates.map((file) => file.name);
      alert(`Files ${name.join(", ")} are duplicate`);
      return;
    }
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type !== "application/pdf") {
        alert(`Upload only PDF File.`);
        return;
      }
      console.log(
        "uploadedFiles.length ::::::::::: " + newUploadedFiles.length
      );
      const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

      console.log(
        "files size :::::::::::::::: " + JSON.stringify(fileSize + fileSizeInMB)
      );

      // if (fileSizeInMB < 25 && fileSize + fileSizeInMB < 25) {
      setfileSize(fileSize + fileSizeInMB);
      newUploadedFiles.push(file);
      // } else {
      //   alert(`File '${file.name}' exceeds the maximum file size of 25 MB.`);
      // }
    }
    setSelectedFiles(newUploadedFiles);

    setUploadedFiles(newUploadedFiles);
    setValue("pdfs", newUploadedFiles, { shouldDirty: true });
  };

  const handleDeleteFile = (e, index) => {
    e.preventDefault();
    clearErrors("pdfs");
    const newUploadedFiles = [...uploadedFiles];
    newUploadedFiles.splice(index, 1);
    setUploadedFiles(newUploadedFiles);
    setSelectedFiles(newUploadedFiles);
    setValue("pdfs", newUploadedFiles, { shouldDirty: true });
  };

  const triggerFileInput = () => {
    // Trigger the file input click event
    fileInputRef.current.click();
  };

  const handlePauseAudio = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      // setIsPlaying(false);
      setplayVoiceId("");
    }
  };

  // Effect 1: Cleanup on unmount
useEffect(() => {
  return () => {
    if(!isActive) {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (blobURL) {
      URL.revokeObjectURL(blobURL);
    }
    setplayVoiceId("");
  }
  };
}, [isActive]);

// Effect 2: Pause when switching tabs/schedules
useEffect(() => {
  if(!isActive) {
  if (audioRef.current) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }
}
  setplayVoiceId("");
}, [scheduleId, isActive]);

  const playMiscFile = (e, message, greetid, greetname, hid) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (message && message.trim() !== "") {
      getAudioFileInfo(message, greetid, greetname, hid);
    }
  };
  const getAudioFileInfo = async (message, greetid, greetname, hid) => {
    try {
      // debugger;
      if (blobURL) URL.revokeObjectURL(blobURL);
      setBlobURL(null);
      audioRef.current?.pause();
      audioRef.current && (audioRef.current.currentTime = 0);

      // const normalizedMessage = await sanitizeAndLowercase(message);
      const normalizedMessage = message;
      let apiResponse = null;

      const cachedData = hid ? holidayCustomInfo?.[hid] : commonGreetInfo;

      if (
        cachedData?.wave_file &&
        normalizedMessage === cachedData.normalized_message
      ) {
        setplayVoiceId(hid || -1);
        const exitfileUrl = URL.createObjectURL(cachedData.actual_wav_file);
        setBlobURL(exitfileUrl);
        return;
      }
      setIsloading(true);
      apiResponse = await getAudioFile(
        message,
        normalizedMessage !== cachedData?.normalized_message
          ? undefined
          : greetid,
        normalizedMessage !== cachedData?.normalized_message
          ? undefined
          : greetname
      );
      setIsloading(false);
      if (apiResponse?.status === 200) {
        const blobObj = await apiResponse.blob();
        console.log("blobObj :::::::::::::::::: ", blobObj);
        const fileUrl = URL.createObjectURL(blobObj);
        console.log("fileUrl :::::::::::::::::: ", fileUrl);

        setBlobURL(fileUrl);
        setplayVoiceId(hid || -1);

        const updateInfo = {
          wave_file: fileUrl,
          actual_wav_file: blobObj,
          normalized_message: normalizedMessage,
        };

        hid
          ? setholidayCustomInfo((prev) => ({
            ...prev,
            [hid]: { ...prev[hid], ...updateInfo },
          }))
          : setcommonGreetingInfo((prev) => ({ ...prev, ...updateInfo }));
      } else {
        const responseData = await apiResponse.json();
        setinterErrorMessage(responseData?.message ?? "Internal Server Error");
      }
    } catch (error) {
      console.error("Unable to load audio file:", error);
    }
  };

  async function getAudioFile(message, greetid, greetname) {
    try {
      const scheduleType =
        scheduleId === 1
          ? "alltime"
          : scheduleId === 2
            ? "open"
            : scheduleId === 3
              ? "closed"
              : "holiday";
      let reqBodyInfo = {
        reqid: 151,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        luna_id: lunaid,
        schedule_type: scheduleType,
      };
      if (greetid) {
        reqBodyInfo.greet_id = greetid;
        reqBodyInfo.greet_name = greetname;
        reqBodyInfo.msg = message;
      } else {
        reqBodyInfo.msg = message;
      }
      console.log(
        "request to play :::::::::::::: " + JSON.stringify(reqBodyInfo)
      );
      let apiResponse = await getLunaGreetingInfo(reqBodyInfo);
      return apiResponse;
    } catch (error) {
      console.log(`Unable to load the audio file : ${error}`);
    }
    return "";
  }

  const downloadMiscFile = (e, message, hid) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (message && message.trim() !== "") {
      getdownloadAudioFileInfo(message, hid);
    }
  };
  const getdownloadAudioFileInfo = async (message, hid) => {
    try {
      let apiResponse = await getAudioFile(message, hid);

      let filename = "";
      if (apiResponse.status == 200) {
        const contentDisposition = apiResponse.headers.get(
          "Content-Disposition"
        );
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // setInternalError(true);
      }
    } catch (error) {
      console.log(`Unable to download the luna audio file : ${error}`);
    }
  };

  useEffect(() => {
    let timer;

    const fetchSummaryInfo = async () => {
      try {
        const saverep = await getSummaryInformation(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          lunaid,
          scheduleId
        );
        const saverepMsg = await saverep.json();
        console.log("value is ::::: " + JSON.stringify(saverepMsg));
        if (saverepMsg.status === 200) {
          if (saverepMsg.data.status === 2) {
            // Final state - stop polling
            setgreetStatus(2);
            reset((prev) => ({
              ...prev,
              greet: {
                ...prev.greet,
                scrap_info: saverepMsg?.data?.scrap_info ?? "",
              },
            }));
          } else if (saverepMsg.data.status === 1) {
            setTimeout(() => {
              fetchSummaryInfo();
            }, 5000);
          } else if (saverepMsg.data.status === 3) {
            setgreetStatus(0);
            setinfoError(saverepMsg?.data?.scrap_info ?? "");
          }
          // If status is still 1, the effect will re-trigger
        }
      } catch (error) {
        console.error("Polling error:", error);
      }
    };

    if (greetStatus === 1) {
      timer = setTimeout(fetchSummaryInfo, 5000);
    }

    return () => clearTimeout(timer);
  }, [greetStatus]);

  useEffect(() => {
    if (greetStatus === 3 && watch("greet.scrap_info") !== "") {
      setgreetStatus(0);
      setinfoError(watch("greet.scrap_info"));
    }
  }, [greetStatus]);

  useEffect(() => {
    if (infoError) {
      const timer = setTimeout(() => {
        setinfoError("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [infoError]);

  const handleToDeletePDFFile = (e, pdfid) => {
    e.preventDefault();
    clearErrors("pdfs");
    const existingfiles = pdfInfo.filter(
      (pdffile) => pdffile.file_id !== pdfid
    );
    setpdfInfo(existingfiles);
    const deleteFiles = [...deletedFilesList, pdfid];
    setdeletedFilesList(deleteFiles);
    setValue("deletepdfs", deleteFiles, { shouldDirty: true });
  };

  const handleDownloadPDF = async (e, pdfid, pdfname) => {
    try {
      e.preventDefault();
      let apiResponse = await downloadLunaPDF(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        lunaid,
        scheduleId,
        pdfid
      );
      console.log("apiResponse ::::::::::::::: " + JSON.stringify(apiResponse));

      let filename = pdfname || "";
      if (apiResponse.status == 200) {
        filename = filename;
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        let saverepMsg = await apiResponse.json();
        setinterErrorMessage(saverepMsg.message);
      }
    } catch (error) {
      console.log("Error in handleDownloadPDF::::::::: " + error);
    }
  };

  return (
    <>
      <div className="section-content">
        <div className="general-settings">Greeting</div>
        {scheduleId === 4 ? (
          <>
            <div className="add-numbermain align-items-start">
              <div className="tel-numbers">
                Use Holiday specific greetings
                <br />
                <span className="phrecording">
                  Enter the greeting this profile will use for each holiday. The
                  selected voice is {voiceType}.
                </span>
              </div>
              <div className="w-50">
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      name="DefualtLocation"
                      checked={watch("greet.is_specific")}
                      onChange={(e) => {
                        setgreetError("");
                        setValue("greet.is_specific", e.target.checked, {
                          shouldDirty: true,
                        });
                      }
                      }
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
                {!watch("greet.is_specific") && (
                  <>
                    <div className="d-flex align-items-end">
                      <div className="mb-4">

                        <MDBIcon
                          far
                          icon={
                            playVoiceId === -1 ? "pause-circle" : "play-circle"
                          }
                          size="lg"
                          color="primary"
                          className="me-3 PlayToolTip mb-3 d-block"
                          onClick={(e) => {
                            if (playVoiceId === -1) {
                              handlePauseAudio(e);
                            } else {
                              playMiscFile(
                                e,
                                watch("greet.msg"),
                                commonGreetingIdName.greet_id,
                                commonGreetingIdName.greet_name
                              );
                            }
                          }}
                        />
                      </div>
                      {/* <MDBIcon
                      fas
                      icon="download"
                      size="lg"
                      color="primary"
                      className="me-2 DownloadToolTip"
                      onClick={(e) => downloadMiscFile(e, watch("greet.msg"))}
                    /> */}
                      <div className="phoneselect w-100 position-relative">
                        <TextareaAutosize
                          maxRows={15}
                          minRows={5}
                          className="form-control pr-4"
                          maxLength={UIConstant.MAX_CHAR_LUNA}
                          value={watch("greet.msg")}
                          onChange={(e) => {
                            clearErrors("greet.msg");
                            setValue("greet.msg", e.target.value, {
                              shouldDirty: true,
                            });
                          }}
                        />
                        <span
                          className="text-muted"
                          style={{
                            fontSize: "10.5px",
                          }}
                        >
                          {watch("greet.msg")?.length || 0}/{UIConstant.MAX_CHAR_LUNA}
                        </span>

                        {errors?.greet?.msg && (
                          <p className="text-danger">
                            {errors?.greet?.msg?.message}
                          </p>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {watch("greet.is_specific") ? (
              <>
                {greetError && <p className="text-danger">{greetError}</p>}
                {fields.map((field, index) => (
                  <>
                    <hr />

                    <div
                      className="add-numbermain align-items-start"
                      key={field.id}
                    >
                      <div className="tel-numbers fw-bold">
                        {field.hldyname}
                        <div className="tel-numbers fw-light  gap-3">
                          <div className="phrecording"><span className="d-inline-block" style={{ width: "50px" }}>From:</span>{field.from}</div>
                          <div className="phrecording"><span className="d-inline-block" style={{ width: "50px" }}>To: </span>{field.to}</div>
                        </div>
                      </div>

                      <div className="w-50 d-flex flex-column">
                        <div className="d-flex">
                          <div className="phoneselect w-100">
                            <div className="position-relative w-100  d-flex align-items-end">
                              <div className="mb-4">
                                <MDBIcon
                                  far
                                  icon={
                                    playVoiceId === field.hlydyid
                                      ? "pause-circle"
                                      : "play-circle"
                                  }
                                  size="lg"
                                  color="primary"
                                  className="me-4 PlayToolTip"
                                  onClick={(e) => {
                                    if (playVoiceId === field.hlydyid) {
                                      handlePauseAudio(e);
                                    } else {
                                      playMiscFile(
                                        e,
                                        watch(`greet.edit_perm.${index}.msg`),
                                        field.greet_id,
                                        field.greet_name,
                                        field.hlydyid
                                      );
                                    }
                                  }}
                                />
                                {/* <MDBIcon
                            fas
                            icon="download"
                            size="lg"
                            color="primary"
                            className="me-2 DownloadToolTip"
                            onClick={(e) =>
                              downloadMiscFile(
                                e,
                                watch(`greet.edit_perm.${index}.msg`),
                                field.hlydyid
                              )
                            }
                          /> */}
                              </div>
                              <TextareaAutosize
                                minRows={5}
                                className="form-control pr-4"
                                maxLength={UIConstant.MAX_CHAR_LUNA}
                                value={watch(`greet.edit_perm.${index}.msg`)}
                                onChange={(e) => {
                                  clearErrors(`greet.edit_perm.${index}.msg`);
                                  setgreetError("");
                                  setValue(
                                    `greet.edit_perm.${index}.msg`,
                                    e.target.value,
                                    {
                                      shouldDirty: true,
                                    }
                                  );
                                }}
                              />
                              <span
                                className=" text-muted"
                                style={{
                                  fontSize: "10.5px",
                                }}
                              >
                                {watch(`greet.edit_perm.${index}.msg`)
                                  ?.length || 0}
                                /{UIConstant.MAX_CHAR_LUNA}
                              </span>
                            </div>
                            {errors?.greet?.edit_perm?.[index]?.msg && (
                              <p className="text-danger">
                                {errors.greet.edit_perm[index].msg.message}
                              </p>
                            )}

                            {/* {errors?.grt?.value && (
                          <p className="text-danger">
                            {errors?.grt?.value?.message}
                          </p>
                        )} */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <>
            <div className="add-numbermain align-items-start">
              <div className="tel-numbers">
                Greeting
                <br />
                <span className="phrecording">
                  Enter the greeting this profile will use. The selected voice
                  is {voiceType}
                </span>
              </div>
              <div className="w-50 d-flex flex-column">
                <div className="d-flex">
                  <div className="phoneselect w-100">
                    <div className="position-relative w-100 d-flex align-items-end">
                      <div className="mb-4">
                        <MDBIcon
                          far
                          icon={
                            playVoiceId === -1 ? "pause-circle" : "play-circle"
                          }
                          size="lg"
                          color="primary"
                          className="me-4 PlayToolTip"
                          onClick={(e) => {
                            if (playVoiceId === -1) {
                              handlePauseAudio(e);
                            } else {
                              playMiscFile(
                                e,
                                watch("greet.msg"),
                                commonGreetingIdName.greet_id,
                                commonGreetingIdName.greet_name
                              );
                            }
                          }}
                        />
                        {/* <MDBIcon
                    fas
                    icon="download"
                    size="lg"
                    color="primary"
                    className="me-2 DownloadToolTip"
                    onClick={(e) => downloadMiscFile(e, watch("greet.msg"))}
                  /> */}
                      </div>
                      <div className="position-relative w-100">

                        <TextareaAutosize
                          minRows={5}
                          maxRows={15}
                          className="form-control pr-4 w-100"
                          maxLength={UIConstant.MAX_CHAR_LUNA}
                          {...register("greet.msg", {
                            required: "Greeting message is required.",
                          })}
                        // onChange={(e) => {
                        //   clearErrors("greet.msg");
                        //   setValue("greet.msg", e.target.value, {
                        //     shouldDirty: true,
                        //   });
                        // }}
                        />
                        <span
                          className="text-muted"
                          style={{
                            fontSize: "10.5px",
                          }}
                        >
                          {watch("greet.msg")?.length || 0}/{UIConstant.MAX_CHAR_LUNA}
                        </span>
                      </div>
                    </div>

                    {errors?.greet?.msg && (
                      <p className="text-danger">
                        {errors?.greet?.msg?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {(greetStatus === 0 || regenerateFlag) && (
          <>
            {regenerateFlag && (
              <>
                <div className="d-flex align-items-center justify-content-end pe-3 pt-3">
                  <MDBIcon
                    fas
                    icon="times"
                    className="me-1 revertRegenetare cursor-pointer"
                    size="lg"
                    onClick={(e) => {
                      e.preventDefault();
                      setregenerateFlag(false);
                    }}
                  />
                </div>
              </>
            )}

            <div className="highlightBg mt-0">
              <div
                className="add-numbermain w-100 border-0 position-relative"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  id="uploadFile"
                  className="upload__img border-0"
                  accept=".pdf"
                  multiple
                  onChange={handleFileUpload}
                  ref={fileInputRef}
                />
                <div className="w-100">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="tel-numbers">
                      {" "}
                      {scheduleId == 4 || scheduleId == 3
                        ? `Inherit information from ${twentyFourSeven ? "24/7" : "Open"
                        }`
                        : "Information"}
                    </div>
                    {
                      (scheduleId == 4 || scheduleId == 3) && (
                        <div className="phoneselect">
                          <label className="switch">
                            <input
                              className="form-control"
                              type="checkbox"
                              name="DefualtLocation"
                              checked={watch("greet.is_inherit_info")}
                              onChange={(e) =>
                                setValue(
                                  "greet.is_inherit_info",
                                  e.target.checked,
                                  {
                                    shouldDirty: true,
                                  }
                                )
                              }
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      )
                      // : (
                      //   <MDBBtn onClick={triggerFileInput}>
                      //     Upload Documents
                      //   </MDBBtn>
                      // )
                    }
                  </div>
                  {!watch("greet.is_inherit_info") && (
                    <>
                      <span class="phrecording text-start w-100 d-inline-block">
                        {scheduleId == 4
                          ? `
            Here is where you put all your information or FAQs you want Luna to know about your company or organization. You can also drop a PDF here.
            `
                          : `
              Here is where you put all your information or FAQs you want Luna
              to know about your company or organization. You can also drop a PDF here.`}
                      </span>
                      <div className="position-relative w-100">
                        <TextareaAutosize
                          minRows={10}
                          maxRows={15}
                          className="form-control w-100 mt-3 pr-4"
                          value={watch("greet.info")}
                          maxLength={5000}
                          onChange={(e) => {
                            clearErrors("greet.info");
                            setinfoError("");
                            setValue("greet.info", e.target.value, {
                              shouldDirty: true,
                            });
                          }}
                        />
                        <span
                          className="text-muted text-end w-100 d-inline-block"
                          style={{
                            fontSize: "10.5px",
                          }}
                        >
                          {watch("greet.info")?.length || 0}/5000
                        </span>
                      </div>
                      {errors?.greet?.info && (
                        <p className="text-danger">
                          {errors?.greet?.info?.message}
                        </p>
                      )}{" "}
                      {infoError && <p className="text-danger">{infoError}</p>}
                    </>
                  )}
                </div>{" "}
              </div>
              {!watch("greet.is_inherit_info") && (
                <>
                  {pdfInfo &&
                    pdfInfo.length > 0 &&
                    pdfInfo.map((fileinfo, index) => (
                      <div
                        className="d-flex align-items-center py-2 px-4"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <MDBIcon
                            fas
                            icon="file-pdf"
                            color="danger"
                            size="lg"
                            className="me-2 "
                          />
                        </div>
                        <div
                          className="fw-bold cursor-pointer"
                          onClick={(e) =>
                            handleDownloadPDF(
                              e,
                              fileinfo.file_id,
                              fileinfo.file_name
                            )
                          }
                        >
                          {fileinfo.file_name}
                        </div>
                        <MDBIcon
                          fas
                          icon="trash"
                          className="ms-3 cursor-pointer"
                          onClick={(e) =>
                            handleToDeletePDFFile(e, fileinfo.file_id)
                          }
                        />
                      </div>
                    ))}
                  {uploadedfileList &&
                    uploadedfileList.length > 0 &&
                    uploadedfileList.map((fileinfo, index) => (
                      <div
                        className="d-flex align-items-center py-2 px-4"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <MDBIcon
                            fas
                            icon="file-pdf"
                            color="danger"
                            size="lg"
                            className="me-2"
                          />
                        </div>
                        <div className="fw-bold">{fileinfo.name}</div>
                        <MDBIcon
                          fas
                          icon="trash"
                          className="ms-3 cursor-pointer"
                          onClick={(e) => handleDeleteFile(e, index)}
                        />
                      </div>
                    ))}
                  {errors?.pdfs && (
                    <p className="text-danger">{errors?.pdfs?.message}</p>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </div>

      {greetStatus === 0 || regenerateFlag ? (
        <>
          {!watch("greet.is_inherit_info") && (
            <>
              <div className="add-numbermain align-items-start">
                <div className="tel-numbers">Website</div>
                <div className="d-flex w-50">
                  <div className="phoneselect w-100">
                    {/* <div className="text-end cursor-pointer mb-1">
                      <MDBIcon fas icon="redo" className="me-2" />
                      Refresh Website
                    </div> */}
                    <MDBInput
                      className="form-control"
                      {...register("greet.weblink", {
                        setValueAs: (v) => v?.trim(),  // as trailing and leading spaces
                        pattern: {
                          value:
                            /^(https?:\/\/)?(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i,
                          message: "Please enter a valid website URL",
                        },
                      })}
                    />
                    {errors?.greet?.weblink && (
                      <p className="text-danger">
                        {errors?.greet?.weblink?.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : greetStatus === 1 ? (
        <>
          <div className="text-center mt-3 border rounded-4 bg-success p-4 text-dark bg-opacity-10">
            <p>Summarization is in progress..</p>
          </div>
        </>
      ) : (
        greetStatus === 2 && (
          <>
            <div>
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div className="tel-numbers">Summarized Data</div>
                <div className="d-flex w-50">
                  <div className="phoneselect w-100">
                    <MDBBtn
                      onClick={(e) => {
                        e.preventDefault();
                        setregenerateFlag(true);
                      }}
                    >
                      <MDBIcon fas icon="redo" className="me-1" /> Regenerate
                    </MDBBtn>
                  </div>
                </div>
              </div>
              <div className="position-relative w-100">
                <TextareaAutosize
                  minRows={3}
                  className="form-control mt-3 pr-4"
                  value={watch("greet.scrap_info")}
                  maxLength={2500}
                  onChange={(e) => {
                    clearErrors("greet.scrap_info");
                    setValue("greet.scrap_info", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                <span
                  className="position-absolute text-muted"
                  style={{ bottom: "5px", right: "10px", fontSize: "12px" }}
                >
                  {watch("greet.scrap_info")?.length || 0}/2500
                </span>
              </div>

              {errors?.greet?.scrap_info && (
                <p className="text-danger">
                  {errors?.greet?.scrap_info?.message}
                </p>
              )}
            </div>
          </>
        )
      )}
      <audio
        ref={audioRef}
        src={blobURL}
        hidden
        autoPlay
        onEnded={handlePauseAudio}
      />
      <Tooltip
        anchorSelect=".PlayToolTip"
        place="top"
        className="exampleTooltip"
      >
        Play
      </Tooltip>

      <Tooltip
        anchorSelect=".DownloadToolTip"
        place="top"
        className="exampleTooltip"
      >
        Download
      </Tooltip>
      <Tooltip
        anchorSelect=".revertRegenetare"
        place="top"
        className="exampleTooltip"
      >
        Revert
      </Tooltip>
    </>
  );
}

export default LunaGreeting;
